
<template lang="html">
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} SHIFT</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">

      <!-- Personal -->

        <vs-divider class="mb-0">Personal</vs-divider>

        <!-- NAMA -->
        <vs-row class="my-5">
          <vs-col vs-w="12">
            <vs-input label="Nama Lengkap" v-model="dataNama" class="w-full" name="Nama" v-validate="'required|min:5'" disabled="true"/>
            <span class="text-danger text-sm" v-show="errors.has('Nama')">{{ errors.first('Nama') }}</span>
          </vs-col>
        </vs-row>

        <vs-row class="mb-5">
          <vs-col vs-w="6" class="text-left">
            <vs-input 
            label="Nomor Ponsel" 
            v-model="dataPonsel" 
            name="Ponsel" 
            v-validate="'required|numeric|min:10|max:13'"
            disabled="true"/>
            <span class="text-danger text-sm" v-show="errors.has('Ponsel')">{{ errors.first('Ponsel') }}</span>
          </vs-col>
          <vs-col vs-w="6" class="text-left">
            <vs-input 
            label="Email" 
            v-model="dataEmail" 
            class="w-full" 
            name="Email" 
            v-validate="'required|email'"
            disabled="true"/>
            <span class="text-danger text-sm" v-show="errors.has('Email')">{{ errors.first('Email') }}</span>
          </vs-col>
        </vs-row>

      <!-- // Personal -->

      <!-- Regu -->

        <vs-divider class="mb-0">Fungsional</vs-divider>

        <vs-row class="mt-5">
          <vs-col vs-w="6" class="pr-2">
            <vs-input v-model="dataNamaTenaga" label="Tenaga" class="w-full" disabled="true"/>
          </vs-col>
          <vs-col vs-w="6" class="pr-2">
            <vs-input v-model="dataNamaKantor" label="Kantor" class="w-full" disabled="true"/>
          </vs-col>
        </vs-row>

      <!-- // Fungsional -->

      <vs-divider class="mb-0">Regu</vs-divider>

        <vs-row class="mt-5">
          <vs-col vs-w="8" class="pr-2">
            <vs-select v-model="dataRegu" label="Regu" class="w-full" autocomplete>
              <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in regu" />
            </vs-select>
          </vs-col>
        </vs-row>

      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>

    <vs-prompt style="z-index: 52012;"
      color="danger"
      title="Add Struktur"
      @accept="submitStruktur"
      @close="close"
      accept-text="Add"
      :buttons-hidden="!isFormStrukturValid"
      :active.sync="activePrompt">
      <div class="con-exemple-prompt">
        <vs-select v-model="dataStrukturHeader" label="Parent" class="mt-5 w-full">
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in strukturHeader" v-validate="'required'"/>
        </vs-select>
        <vs-input label="Struktur" v-model="dataStrukturAdd" class="mt-5 mb-5 w-full" name="item-title" v-validate="'required'" />
      </div>
     </vs-prompt>

  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapGetters } from 'vuex'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    flatPickr,
  },
  data () {
    return {

      dataId: null,
      dataNama: null,
      dataPonsel: null,
      dataEmail: null,
      dataAlamat: null,
      dataImg: null,
      dataTanggalLahir: null,
      dataStatus: false,

      dataStruktur: null,
      dataTanggalMulai: null,
      dataIDPegawai: null,
      dataTenaga: null,
      dataKantor: null,
      dataNamaTenaga: null,
      dataNamaKantor: null,

      dataRegu: null,
      dataNamaRegu: null,

      dataUsername: null,
      usernameEdit: false,

      struktur: [],
      strukturHeader: [],
      tenaga: [],
      kantor: [],
      regu: [],
      status: null,

      dataStrukturHeader: null,
      dataStrukturAdd: null,

      upImg: true,

      activePrompt: false,
      AddStruktur: false,

      close: false,

      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },

    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.getStruktur()
        this.getTenaga()
        this.getKantor()
        this.getRegu()
        this.$validator.reset()
      } else {
        const { id, nama, ponsel, email, alamat, foto, tanggal_lahir, status, struktur, tanggal_mulai, idpegawai, tenaga, username, kantor, nametenaga, namekantor, regu, nameregu } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataNama = nama
        this.dataPonsel = ponsel
        this.dataEmail = email
        this.dataAlamat = alamat
        this.dataImg = foto
        this.dataTanggalLahir = tanggal_lahir
        this.dataStruktur = struktur
        this.dataTanggalMulai = tanggal_mulai
        this.dataIdPegawai = idpegawai
        this.dataTenaga = tenaga
        this.dataKantor = kantor
        this.dataRegu = regu
        this.dataNamaTenaga = nametenaga
        this.dataNamaRegu = nameregu
        this.dataNamaKantor = namekantor
        this.dataUsername = username
        if (status === '0') {
          this.dataStatus = false
        } else {
          this.dataStatus = true
        }
        this.usernameEdit = true

        this.getStruktur()
        this.getTenaga()
        this.getKantor()
        this.getRegu()
        this.initValues()
      }
    },
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataRegu
    },
    isFormStrukturValid () {
      return this.dataStrukturHeader && this.dataStrukturAdd
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    ...mapGetters({
      user : 'auth/user',
    }),
    /*
    dataUsername () {
      var slug = this.sanitizeNama(this.dataNama);
      return slug;
    }
    username() {
      var slug = this.sanitizeNama(this.dataNama);
      return slug
    }
    */
  },
  methods: {
    getStruktur(){
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      this.axios.get('/list-struktur', configs)
      .then((response) => {
        let {data} = response.data
        this.struktur = data
      })
      .catch((error) => {
        let data = error.data
        this.struktur = data
      })

      this.axios.get('/list-struktur-header', configs)
      .then((response) => {
        let {data} = response.data
        this.strukturHeader = data
      })
      .catch((error) => {
        let data = error.data
        this.strukturHeader = data
      })
    },
    getTenaga(){
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      this.axios.get('/list-tenaga', configs)
      .then((response) => {
        let {data} = response.data
        this.tenaga = data
      })
      .catch((error) => {
        let data = error.data
        this.tenaga = data
      })
    },
    getKantor(){
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      this.axios.get('/list-kantor', configs)
      .then((response) => {
        let {data} = response.data
        this.kantor = data
      })
      .catch((error) => {
        let data = error.data
        this.kantor = data
      })
    },
    getRegu(){
      let configs = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      this.axios.get('/list-regu', configs)
      .then((response) => {
        let {data} = response.data
        this.regu = data
      })
      .catch((error) => {
        let data = error.data
        this.regu = data
      })
    },
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataNama = null
      this.dataPonsel = null
      this.dataEmail = null
      this.dataAlamat = null
      this.dataImg = null
      this.dataTanggalLahir = null

      this.dataStruktur = null
      this.dataTanggalMulai = null
      this.dataIDPegawai = null
      this.dataTenaga = null

      this.dataUsername = null
      this.dataStatus = false
      this.usernameEdit = false
    },
    initValuesStruktur () {
      this.dataStrukturHeader = null
      this.dataStrukturAdd = null
    },
    submitData () {
      this.$vs.loading()
      this.$validator.validateAll().then(result => {
        if (result) {
          let formData = new FormData();
          const config = { 
            headers: { 'Content-Type' : 'multipart/form-data' } 
          };
          formData.set('regu', this.dataRegu);
          formData.set('id', this.dataId);
          this.$store.dispatch('shift/updateShift', formData, config)
          .then((response) => {
            this.$vs.loading.close()
            this.$emit('closeSidebar')
            this.$vs.notify({
              title: 'Berhasil',
              color  : 'success',
              text  : response.message,
            })
          })
          .catch(error => {
            this.$vs.loading.close()
            let {data} = error.response
            this.$vs.notify({
              color  : 'danger',
              text  : data.message,
            })
          }) 
        }
      })
    },
    addStruktur() {
      this.struktur = null
      this.getStruktur()
      this.activePrompt = true
    },
    submitStruktur () {
      this.struktur = null
      this.strukturHeader = null
      this.$vs.loading()
      let formData = {
        'name': this.dataStrukturAdd,
        'parent': this.dataStrukturHeader,
        'term_group': '6'
      }

      let config = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }

      this.axios.post('/term-add-form', formData, config)
      .then((response) => {

        this.$vs.notify({
          title: response.status,
          color  : 'success',
          text  : 'Added Struktur',
        })
        this.$vs.loading.close()

      })
      .catch((error) => {
        this.$vs.loading.close()
        let { data } = error.response
        this.$vs.notify({
          title: 'Error',
          text: data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
      this.initValuesStruktur()
      this.getStruktur()
    },
    pushStruktur () {
      this.getStruktur()
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    sanitizeNama (nama) {
      var slug = "";
      // Change to lower case
      var titleLower = nama.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
      // Letter "d"
      slug = slug.replace(/đ/gi, 'd');
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, '');
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, '_');
      //this.dataUsername = slug;
      return slug;
    }
  }
}
</script>
<style>
#editor {
  min-height:500px;
}
</style>
<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 500px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
